import { useState } from "react";

const INIT_PROCEDURES = [
  { id:1,  name:"Laparoscopic Appendectomy",     procedure_type:"Surgery",              standard_charges:25000,  description:"Laparoscopic removal of inflamed appendix",           active:1 },
  { id:2,  name:"Open Appendectomy",             procedure_type:"Surgery",              standard_charges:18000,  description:"Open surgical removal of appendix",                   active:1 },
  { id:3,  name:"Laparoscopic Cholecystectomy",  procedure_type:"Surgery",              standard_charges:30000,  description:"Laparoscopic removal of gallbladder",                 active:1 },
  { id:4,  name:"Total Knee Replacement",        procedure_type:"Orthopedic Procedure", standard_charges:85000,  description:"Total knee arthroplasty for severe osteoarthritis",   active:1 },
  { id:5,  name:"Total Hip Replacement",         procedure_type:"Orthopedic Procedure", standard_charges:90000,  description:"Total hip arthroplasty",                              active:1 },
  { id:6,  name:"CABG (Coronary Artery Bypass)", procedure_type:"Cardiac Procedure",    standard_charges:200000, description:"Coronary artery bypass grafting — 3 vessel",          active:1 },
  { id:7,  name:"Angioplasty + Stenting",        procedure_type:"Cardiac Procedure",    standard_charges:150000, description:"Percutaneous coronary intervention with stent",       active:1 },
  { id:8,  name:"Caesarean Section (C-Section)", procedure_type:"Obstetric Procedure",  standard_charges:35000,  description:"Surgical delivery of baby via abdominal incision",    active:1 },
  { id:9,  name:"Hysterectomy (Laparoscopic)",   procedure_type:"Obstetric Procedure",  standard_charges:55000,  description:"Laparoscopic removal of uterus",                      active:1 },
  { id:10, name:"Hernia Repair (Laparoscopic)",  procedure_type:"Surgery",              standard_charges:22000,  description:"Laparoscopic repair of inguinal or umbilical hernia", active:1 },
  { id:11, name:"ICD Insertion",                 procedure_type:"Minor Procedure",      standard_charges:5000,   description:"Intercostal drain for pleural effusion",               active:1 },
  { id:12, name:"Ascitic Tap",                   procedure_type:"Minor Procedure",      standard_charges:2500,   description:"Drainage of fluid from abdominal cavity",             active:1 },
  { id:13, name:"Central Line Insertion",        procedure_type:"Minor Procedure",      standard_charges:3500,   description:"Insertion of central venous catheter",                active:1 },
  { id:14, name:"Lumbar Puncture",               procedure_type:"Minor Procedure",      standard_charges:2000,   description:"Spinal tap for CSF sampling",                         active:1 },
  { id:15, name:"Wound Debridement",             procedure_type:"Minor Procedure",      standard_charges:3000,   description:"Surgical cleaning and removal of dead tissue",        active:1 },
  { id:16, name:"Upper GI Endoscopy (OGD)",      procedure_type:"Endoscopy",            standard_charges:5000,   description:"Endoscopic examination of esophagus and stomach",     active:1 },
  { id:17, name:"Colonoscopy",                   procedure_type:"Endoscopy",            standard_charges:7000,   description:"Endoscopic examination of large intestine",           active:1 },
  { id:18, name:"Bronchoscopy",                  procedure_type:"Endoscopy",            standard_charges:8000,   description:"Endoscopic examination of airways",                   active:1 },
  { id:19, name:"Liver Biopsy",                  procedure_type:"Biopsy",               standard_charges:6000,   description:"Percutaneous needle biopsy of liver",                 active:0 },
  { id:20, name:"Bone Marrow Biopsy",            procedure_type:"Biopsy",               standard_charges:7000,   description:"Bone marrow aspiration and biopsy",                   active:1 },
];

const TYPE_STYLE = {
  "Surgery":               { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
  "Minor Procedure":       { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Endoscopy":             { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Biopsy":                { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "Cardiac Procedure":     { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
  "Orthopedic Procedure":  { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Obstetric Procedure":   { bg:"rgba(236,72,153,.12)",  color:"#ec4899" },
  "Other":                 { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
};
const TYPE_ICON = {
  "Surgery":"🔪","Minor Procedure":"🩹","Endoscopy":"🔭",
  "Biopsy":"🧫","Cardiac Procedure":"❤️","Orthopedic Procedure":"🦴",
  "Obstetric Procedure":"🤱","Other":"📋",
};

const ALL_TYPES = ["Surgery","Minor Procedure","Endoscopy","Biopsy","Cardiac Procedure","Orthopedic Procedure","Obstetric Procedure","Other"];
const TYPE_FILTERS = ["All", ...ALL_TYPES];

const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{--bg:#0A0C12;--bg2:#111318;--bg3:#181B24;--bg4:#1E2130;--border:#252836;--border2:#2E3348;--text:#EDF0FF;--muted:#6B7A99;--dim:#3D4563;--accent:#5E7BFF;--accent2:#8B9FFF;--green:#10B981;--red:#EF4444;--amber:#F59E0B;--blue:#3B82F6;}
body{background:var(--bg);color:var(--text);font-family:'IBM Plex Sans',sans-serif;min-height:100vh;}
.page{max-width:1200px;margin:0 auto;padding:24px 20px;}
.ph{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}
.ph-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;}
.ph-sub{font-size:12px;color:var(--muted);margin-top:2px;}
.sr{display:grid;gap:12px;margin-bottom:20px;}
.sc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px 18px;}
.sl{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;margin-bottom:6px;}
.sv{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;}
.sb{height:3px;border-radius:2px;margin-top:8px;}
.fb{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:12px 16px;display:flex;gap:10px;align-items:center;margin-bottom:14px;flex-wrap:wrap;}
.sw{position:relative;flex:1;min-width:180px;}
.si{position:absolute;left:10px;top:50%;transform:translateY(-50%);color:var(--muted);font-size:13px;pointer-events:none;}
.input{width:100%;padding:8px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);color:var(--text);font-size:12px;font-family:'IBM Plex Sans',sans-serif;outline:none;transition:border-color .15s;}
.input:focus{border-color:var(--accent);}
.sip{padding-left:32px;}
.sel{appearance:none;cursor:pointer;}
.tg{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:12px;}
.tc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px;transition:border-color .15s;}
.tc:hover{border-color:var(--border2);}
.tc.off{opacity:.55;}
.tch{display:flex;align-items:flex-start;gap:10px;margin-bottom:10px;}
.tci{width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;}
.tcn{font-size:13px;font-weight:600;line-height:1.4;}
.tcd{font-size:11px;color:var(--muted);line-height:1.5;margin-bottom:8px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}
.tcf{display:flex;align-items:center;gap:6px;padding-top:10px;border-top:1px solid var(--border);flex-wrap:wrap;}
.chip{display:inline-flex;align-items:center;padding:2px 8px;border-radius:6px;font-size:10px;font-weight:600;}
.price{font-family:'IBM Plex Mono',monospace;font-size:15px;font-weight:600;color:var(--accent2);margin-left:auto;}
.ib{width:26px;height:26px;border-radius:6px;border:1px solid var(--border2);background:transparent;color:var(--muted);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11px;transition:all .15s;}
.ib:hover{border-color:var(--accent2);color:var(--accent2);}
.ib.d:hover{border-color:#ef4444;color:#ef4444;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;border:none;font-family:'IBM Plex Sans',sans-serif;transition:all .15s;}
.bp{background:var(--accent);color:#fff;}
.bp:hover{background:#4a67e8;}
.bg_{background:var(--bg3);color:var(--text);border:1px solid var(--border2);}
.bg_:hover{border-color:var(--accent2);}
.empty{padding:40px;text-align:center;color:var(--muted);}
.mb{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:50;display:flex;align-items:center;justify-content:center;padding:20px;}
.mx{background:var(--bg2);border:1px solid var(--border2);border-radius:16px;padding:28px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto;}
.mt{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;}
.mg{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}
.mf{grid-column:1/-1;}
.field{display:flex;flex-direction:column;gap:5px;}
.field label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;}
.ta{resize:vertical;min-height:70px;}
.ma{display:flex;gap:8px;justify-content:flex-end;margin-top:16px;padding-top:14px;border-top:1px solid var(--border);}
.tw{display:flex;align-items:center;gap:10px;}
.tgl{width:40px;height:22px;border-radius:11px;background:var(--bg3);border:1px solid var(--border2);position:relative;cursor:pointer;transition:all .2s;}
.tgl.on{background:var(--accent);border-color:var(--accent);}
.tk{position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;top:2px;left:2px;transition:left .2s;}
.tgl.on .tk{left:20px;}
.err{font-size:11px;color:#ef4444;margin-top:3px;}
.dw{background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);border-radius:8px;padding:10px 14px;font-size:12px;color:#ef4444;margin-bottom:14px;}
.toast{position:fixed;bottom:24px;right:24px;background:var(--bg3);border:1px solid var(--border2);border-radius:10px;padding:12px 18px;display:flex;align-items:center;gap:10px;font-size:13px;font-weight:500;z-index:100;animation:su .25s ease;}
@keyframes su{from{transform:translateY(16px);opacity:0}to{transform:translateY(0);opacity:1}}
`;

function Modal({ title, onClose, children }) {
  return (
    <div className="mb" onClick={onClose}>
      <div className="mx" onClick={e => e.stopPropagation()}>
        <div className="mt">{title}<button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>
        {children}
      </div>
    </div>
  );
}

function AddEditProcedureModal({ onClose, proc, onSave }) {
  const isEdit = Boolean(proc);
  const [f, setF] = useState({
    name: proc?.name ?? "", procedure_type: proc?.procedure_type ?? "Surgery",
    standard_charges: proc?.standard_charges ?? "", description: proc?.description ?? "",
    active: proc?.active ?? 1,
  });
  const [errs, setErrs] = useState({});
  const [saving, setSaving] = useState(false);
  const set = (k, v) => { setF(p => ({ ...p, [k]: v })); setErrs(p => ({ ...p, [k]: "" })); };
  const save = () => {
    const e = {};
    if (!f.name.trim()) e.name = "Required";
    if (!f.standard_charges || f.standard_charges <= 0) e.standard_charges = "Required";
    if (Object.keys(e).length) { setErrs(e); return; }
    setSaving(true);
    setTimeout(() => onSave({ ...f, standard_charges: parseFloat(f.standard_charges) }), 400);
  };
  return (
    <Modal title={isEdit ? `Edit — ${proc.name}` : "Add Procedure"} onClose={onClose}>
      <div className="mg">
        <div className="field mf">
          <label>Procedure Name *</label>
          <input className="input" value={f.name} onChange={e => set("name", e.target.value)} placeholder="e.g. Laparoscopic Appendectomy"/>
          {errs.name && <span className="err">{errs.name}</span>}
        </div>
        <div className="field">
          <label>Type *</label>
          <select className="input sel" value={f.procedure_type} onChange={e => set("procedure_type", e.target.value)}>
            {ALL_TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Standard Charges (₹) *</label>
          <input className="input" type="number" min="0" value={f.standard_charges} onChange={e => set("standard_charges", e.target.value)}/>
          {errs.standard_charges && <span className="err">{errs.standard_charges}</span>}
        </div>
        <div className="field">
          <label>Status</label>
          <div className="tw" style={{marginTop:6}}>
            <div className={`tgl ${f.active ? "on" : ""}`} onClick={() => set("active", f.active ? 0 : 1)}><div className="tk"/></div>
            <span style={{fontSize:12}}>{f.active ? "Active" : "Inactive"}</span>
          </div>
        </div>
        <div className="field mf">
          <label>Description</label>
          <textarea className="input ta" value={f.description} onChange={e => set("description", e.target.value)} placeholder="Brief description of the procedure…"/>
        </div>
      </div>
      <div className="ma">
        <button className="btn bg_" onClick={onClose}>Cancel</button>
        <button className="btn bp" onClick={save} disabled={saving}>{saving ? "Saving…" : isEdit ? "Update Procedure" : "Add Procedure"}</button>
      </div>
    </Modal>
  );
}

function DeleteConfirmModal({ onClose, onConfirm, name }) {
  return (
    <Modal title="Confirm Delete" onClose={onClose}>
      <div className="dw">⚠ This will permanently delete the procedure. Existing orders will NOT be affected.</div>
      <div style={{fontSize:13, color:"var(--muted)", marginBottom:14}}>{name}</div>
      <div className="ma">
        <button className="btn bg_" onClick={onClose}>Cancel</button>
        <button className="btn" style={{background:"rgba(239,68,68,.15)",color:"#ef4444",border:"1px solid rgba(239,68,68,.3)"}} onClick={onConfirm}>Yes, Delete</button>
      </div>
    </Modal>
  );
}

export default function ProcedureMaster() {
  const [procedures, setProcedures] = useState(INIT_PROCEDURES);
  const [typeF, setTypeF] = useState("All");
  const [search, setSearch] = useState("");
  const [actF, setActF] = useState("All");
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);

  const showToast = msg => { setToast(msg); setTimeout(() => setToast(null), 2500); };
  const close = () => setModal(null);

  const stats = {
    total: procedures.length,
    active: procedures.filter(p => p.active).length,
    inactive: procedures.filter(p => !p.active).length,
    types: [...new Set(procedures.map(p => p.procedure_type))].length,
  };

  const filtered = procedures.filter(p => {
    const tf = typeF === "All" || p.procedure_type === typeF;
    const af = actF === "All" || (actF === "1" ? p.active === 1 : p.active === 0);
    const sf = !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.description?.toLowerCase().includes(search.toLowerCase());
    return tf && af && sf;
  });

  const handleSave = (form) => {
    if (modal?.data) {
      setProcedures(ps => ps.map(p => p.id === modal.data.id ? { ...p, ...form } : p));
      showToast("Procedure updated");
    } else {
      setProcedures(ps => [{ ...form, id: Date.now() }, ...ps]);
      showToast("Procedure added successfully");
    }
    close();
  };

  const handleDelete = () => {
    setProcedures(ps => ps.filter(p => p.id !== modal.data.id));
    showToast("Procedure deleted");
    close();
  };

  return (
    <>
      <style>{css}</style>
      <div className="page">
        {/* Header */}
        <div className="ph">
          <div>
            <div className="ph-title">🔪 Procedure Master</div>
            <div className="ph-sub">Manage procedure catalog with charges and type classification</div>
          </div>
          <button className="btn bp" onClick={() => setModal({ type:"add" })}>+ Add Procedure</button>
        </div>

        {/* Stats */}
        <div className="sr" style={{gridTemplateColumns:"repeat(4,1fr)"}}>
          {[
            { l:"Total Procedures", v:stats.total,    c:"var(--accent2)", b:"rgba(94,123,255,.3)" },
            { l:"Active",           v:stats.active,   c:"var(--green)",   b:"rgba(16,185,129,.3)" },
            { l:"Inactive",         v:stats.inactive, c:"var(--red)",     b:"rgba(239,68,68,.3)" },
            { l:"Types",            v:stats.types,    c:"var(--amber)",   b:"rgba(245,158,11,.3)" },
          ].map(s => (
            <div className="sc" key={s.l}>
              <div className="sl">{s.l}</div>
              <div className="sv" style={{color:s.c}}>{s.v}</div>
              <div className="sb" style={{background:s.b}}/>
            </div>
          ))}
        </div>

        {/* Type filter chips */}
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:14}}>
          {TYPE_FILTERS.map(t => {
            const tc = TYPE_STYLE[t] || { bg:"var(--bg3)", color:"var(--muted)" };
            const cnt = t === "All" ? procedures.length : procedures.filter(p => p.procedure_type === t).length;
            return (
              <button key={t} onClick={() => setTypeF(t)} style={{padding:"5px 12px",borderRadius:20,border:"1px solid",cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",fontSize:11,fontWeight:600,transition:"all .15s",background:typeF===t?tc.color:tc.bg,color:typeF===t?"#fff":tc.color,borderColor:typeF===t?tc.color:`${tc.color}44`}}>
                {t} ({cnt})
              </button>
            );
          })}
        </div>

        {/* Filter bar */}
        <div className="fb">
          <div className="sw"><span className="si">🔍</span><input className="input sip" placeholder="Search procedure name or description…" value={search} onChange={e => setSearch(e.target.value)}/></div>
          <select className="input sel" style={{width:130}} value={actF} onChange={e => setActF(e.target.value)}>
            <option value="All">All Status</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
          <span style={{fontSize:11,color:"var(--muted)"}}>{filtered.length} procedure{filtered.length !== 1 ? "s" : ""}</span>
        </div>

        {/* Cards grid */}
        {filtered.length === 0
          ? <div className="empty">No procedures found</div>
          : (
            <div className="tg">
              {filtered.map(proc => {
                const tc = TYPE_STYLE[proc.procedure_type] || { bg:"var(--bg3)", color:"var(--muted)" };
                return (
                  <div key={proc.id} className={`tc${!proc.active ? " off" : ""}`}>
                    <div className="tch">
                      <div className="tci" style={{background:tc.bg}}>{TYPE_ICON[proc.procedure_type] || "📋"}</div>
                      <div style={{flex:1}}>
                        <div className="tcn">{proc.name}</div>
                      </div>
                      <div style={{display:"flex",gap:4,flexShrink:0}}>
                        <button className="ib" onClick={() => setModal({ type:"edit", data:proc })}>✎</button>
                        <button className="ib d" onClick={() => setModal({ type:"del", data:proc })}>🗑</button>
                      </div>
                    </div>
                    {proc.description && <div className="tcd">{proc.description}</div>}
                    <div className="tcf">
                      <span className="chip" style={{background:tc.bg,color:tc.color}}>{proc.procedure_type}</span>
                      <span className="chip" style={{background:proc.active?"rgba(16,185,129,.1)":"rgba(239,68,68,.1)",color:proc.active?"#10b981":"#ef4444"}}>{proc.active?"Active":"Inactive"}</span>
                      <span className="price">₹{proc.standard_charges?.toLocaleString()}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )
        }
      </div>

      {modal?.type === "add"  && <AddEditProcedureModal onClose={close} proc={null}       onSave={handleSave}/>}
      {modal?.type === "edit" && <AddEditProcedureModal onClose={close} proc={modal.data} onSave={handleSave}/>}
      {modal?.type === "del"  && <DeleteConfirmModal    onClose={close} name={modal.data.name} onConfirm={handleDelete}/>}
      {toast && <div className="toast"><span style={{color:"var(--green)",fontSize:16}}>✓</span>{toast}</div>}
    </>
  );
}
